<template>
    <div class="card mb-4">
        <div class="card-header">
            <div class="row">
                <div class="col-6">
                    <h3 class="pull-left">
                        <strong>{{ trans.get('checkout.agency_book_reference') }}</strong>
                    </h3>
                </div>
                <div class="col-6">
                    <div class="text-right">
                        <i>
                            <small>{{ trans.get('checkout.will_appear_on_agency_invoice') }}</small>
                        </i>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12 col-12">
                    <div class="form__controls form__controls--default">
                        <input-error field="agency_reference"></input-error>
                        <input :disabled="loading"
                               id="agency_reference"
                               type="text"
                               class="field form-control"
                               v-model="agency_reference">
                    </div><!-- /.form__controls -->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vuex-map-fields';
    import InputError from './InputError';

    export default {
        name    : 'agency-booking-ref',
        props   : {},
        data() {
            return {};
        },
        methods : {},
        computed: {
            ...mapFields([
                'order.agency_reference',
                'loading',
            ]),
            isValid() {
                return true;
            },
        },
        mounted() {
        },
        components: {
            InputError
        }
    }
</script>


<style scoped>

    .form__controls input.field:disabled {
        cursor: default;
        background-color: #E9ECEF !important;
        -webkit-box-shadow: 0 0 0 1000px #E9ECEF inset;
    }

</style>
